import styled from 'styled-components';
import { colorUsage } from 'stylesheet';
var LinkURL = styled.a.withConfig({
  displayName: "ExternalLinkstyle__LinkURL",
  componentId: "sc-fcj7aq-0"
})(["grid-area:link-url;color:", ";"], colorUsage.externalLinkForeground);
export { LinkURL };